// extracted by mini-css-extract-plugin
module.exports = {"cntr":"index-module_cntr-17VRh","numCntr":"index-module_numCntr-utbDT","item":"index-module_item-3TsK_"};